import { render, staticRenderFns } from "./mprfq-add-or-update.vue?vue&type=template&id=5cb232e6&scoped=true"
import script from "./mprfq-add-or-update.vue?vue&type=script&lang=js"
export * from "./mprfq-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./mprfq-add-or-update.vue?vue&type=style&index=0&id=5cb232e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb232e6",
  null
  
)

export default component.exports